export default __webpack_public_path__ + "static/media/qr-code.84ce1b5f.webp";